import React, { ReactElement } from 'react';
import styled, { css } from 'styled-components';
import { media, spaces } from '../../lib/styles';

type GapSize = 'space7' | 'space10' | 'space14';

interface ColumnsProps {
    children: Array<ReactElement<ColumnProps> | null> | ReactElement<ColumnProps> | null;
    grid?: boolean;
    rowGap?: false | [GapSize, GapSize, GapSize, GapSize];
    colGap?: false | [GapSize, GapSize, GapSize, GapSize];
}

interface ColumnProps {
    children: React.ReactNode;
    width?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
}

const Columns = styled.div<ColumnsProps>(
    ({ children, grid = true, colGap = false, rowGap = false }) => {
        const columnsCount = React.Children.count(children);
        const baseColumnsCount = grid ? 12 : columnsCount;

        return css`
            display: grid;
            grid-template-columns: repeat(${baseColumnsCount}, 1fr);

            ${grid &&
            css`
                grid-column-gap: ${spaces.halfGutter}px;

                @media ${media('medium')} {
                    grid-column-gap: ${spaces.gutter}px;
                }

                @media ${media('normal')} {
                    grid-column-gap: ${spaces.gutter}px;
                }

                @media ${media('large')} {
                    grid-column-gap: ${spaces.gutter}px;
                }
            `}

            ${rowGap &&
            /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
            /* @ts-ignore */
            css`
                grid-row-gap: ${spaces[rowGap[0]]}px;

                @media ${media('medium')} {
                    grid-row-gap: ${spaces[rowGap[1]]}px;
                }

                @media ${media('normal')} {
                    grid-row-gap: ${spaces[rowGap[2]]}px;
                }

                @media ${media('large')} {
                    grid-row-gap: ${spaces[rowGap[3]]}px;
                }
            `}

        ${colGap &&
            css`
                grid-column-gap: ${spaces[colGap[0]]}px;

                @media ${media('medium')} {
                    grid-column-gap: ${spaces[colGap[1]]}px;
                }

                @media ${media('normal')} {
                    grid-column-gap: ${spaces[colGap[2]]}px;
                }

                @media ${media('large')} {
                    grid-column-gap: ${spaces[colGap[3]]}px;
                }
            `}

        ${Column} {
                grid-column-start: span ${Math.floor(baseColumnsCount / columnsCount)};
            }
        `;
    }
);

const Column = styled.div<{ width?: number[] }>(({ width }) => {
    if (width) {
        return css`
            grid-column-start: span ${width[0]} !important;

            @media ${media('medium')} {
                grid-column-start: span ${width[1]} !important;
            }

            @media ${media('normal')} {
                grid-column-start: span ${width[2]} !important;
            }

            @media ${media('large')} {
                grid-column-start: span ${width[3]} !important;
            }
        `;
    } else {
        return css``;
    }
    return css``;
});

Column.displayName = 'Column';

export { Column };
export default Columns;
